import * as React from "react"

import CtxDepartementAgencesSection from "../ctx-departement-agences/CtxDepartementAgencesSection"

const CtxRegionAgencesSection = ({
  subTitle,
  regionName,
  agenciesData,
}) => {
  

  return <CtxDepartementAgencesSection subTitle={subTitle} regionName={regionName} agenciesData={agenciesData}/>
}

export const name = "CtxRegionAgencesSection"

export const init = (componentData, pageContext) => {

  const regionByDepSlug = {}
  for(const r of pageContext.regionsDepartementsData) {
    for(const d of r.attributes.departements.data) {
      regionByDepSlug[d.attributes.slug] = r
    }
  }
  const agenciesByRegionSlug = {}

  for (const agencyData of pageContext.slAgenciesData) {
    const depSlug = agencyData.attributes.locationDepartement.data.attributes.slug    
    const regionSlug = regionByDepSlug[depSlug].attributes.slug
    if( agenciesByRegionSlug.hasOwnProperty(regionSlug)) {
      agenciesByRegionSlug[regionSlug].push(agencyData)
    } else {
      agenciesByRegionSlug[regionSlug] = [agencyData]
    }
  }

  return (
    <CtxRegionAgencesSection
      key={componentData.id}
      subTitle={componentData.subTitle}
      regionName={pageContext.itemData.attributes.name}
      agenciesData={agenciesByRegionSlug[pageContext.itemData.attributes.slug]}
    />
  )
}

export default CtxRegionAgencesSection
